import { CteValidationEvent } from './cte-monitoring.interface';
import { RegisterValidationStatusType, TradeRepositoryType } from './register.interface';

export interface ICTe {
  id: number;
  nct: string;
  accessKey: string;
  takerName: string;
  issueDate: string;
  value: number;
  events: CteValidationEvent[];
  registers: Array<{
    ctedIs: number;
    registerBatchId: number;
    registerDate: string;
    tradeRepository: TradeRepositoryType;
    status: RegisterValidationStatusType;
    batchUuid?: string;
    registerUuid?: string;
  }>;
  takerBranchId: number;
}

export interface ICteConciliation {
  contractId: number;
  cteId: number;
  settlementValue: number;
  nct: string;
  paymentDueIn: string;
  rebate: number;
  value: number;
}

export interface ICTeSecondaryOperation {
  id: number;
  status: string;
  nct: string;
  accessKey: string;
  cfop: number;
  cteType: string;
  serviceType: string;
  issueDate: string;
  value: number;
  signatureDigest: string;
  originFileKey: string;
  takerName: string;
  takerDocumentNumber: string;
  carrierDocumentNumber: string;
  nContract: number;
  dueDate: string;
  carrierTradeName: string;
  tax?: number;
  opValue?: number;
}

export interface ICTeTaxes {
  cteId: number;
  tax: number;
  operationValue: number;
}

export enum CteStatus {
  SIMULATION = 'SIMULATION',
  AVAILABLE = 'AVAILABLE',
  CONTRACTED = 'CONTRACTED',
  REJECTED = 'REJECTED',
  DISABLED = 'DISABLED',
}
